import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import ContractPartnerButtons from '../../shared/Buttons'
import { tabs } from './tabs'

const List = () => {
    const { t } = useTranslation('contract')
    const { TabComponent, TabProps } = useTabs({
        tabs: tabs(t),
        clearFilters: true,
    })

    return (
        <div>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.partnerContractList,
                        title: t('contract-partners'),
                    },
                ]}
                components={[
                    <ContractPartnerButtons.Create key="create-contract" />,
                ]}
            />
            <Tabs {...TabProps} />
            {TabComponent}
        </div>
    )
}

export default List
